"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomResponseSkillType = void 0;
var CustomResponseSkillType;

(function (CustomResponseSkillType) {
  CustomResponseSkillType["TICKET"] = "CREATE_TICKET";
  CustomResponseSkillType["HELP"] = "HELP";
  CustomResponseSkillType["MEETING"] = "SCHEDULING";
})(CustomResponseSkillType = exports.CustomResponseSkillType || (exports.CustomResponseSkillType = {}));